import './Card.scss';

function Card(props) {
     const { subTitle, picto, children } = props;
     return (
          <div className="card">
               <div className="picto">
                    <img src={picto.src} alt="" />
               </div>
               {subTitle ? <p className="card__subtitle">{subTitle}</p> : null}
               {children}
          </div>
     );
}

export default Card;
